// extracted by mini-css-extract-plugin
export var addButton = "_aj-0";
export var border = "_aj-8";
export var check = "_aj-h";
export var danger = "_aj-6";
export var dropdownContainer = "_aj-1";
export var editModalBody = "_aj-j";
export var footerContainer = "_aj-i";
export var fullWidth = "_aj-a";
export var hide = "_aj-9";
export var icon = "_aj-3";
export var input = "_aj-7";
export var inputFlex = "_aj-b";
export var inputWrapper = "_aj-c";
export var manualFocus = "_aj-5";
export var optionButton = "_aj-4";
export var pillWrapper = "_aj-e";
export var pointer = "_aj-2";
export var showOverflow = "_aj-f";
export var tagsFlex = "_aj-d";
export var xButton = "_aj-g";